<ag-grid-angular class="ag-theme-balham"
                 style="position:absolute;left:0;right:0;top:0;bottom:0;"
                 [gridOptions]="gridOptions"
                 (gridReady)="onReadyGrid($event)">
</ag-grid-angular>
